import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchWallet, setSearchWallet] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const currentPath = location.pathname;

  const handleSearch = () => {
    if (searchWallet.trim()) {
      navigate(`/dev/${encodeURIComponent(searchWallet.trim())}`);
      setMobileMenuOpen(false);
    }
  };

  const handleNavigation = (path) => {
    navigate(path);
    setMobileMenuOpen(false);
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h1 onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>🚀 DevRadar.fun</h1>
          
          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={mobileMenuOpen ? 'hamburger open' : 'hamburger'}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>

        {/* Desktop Navigation */}
        <div className="header-nav desktop-nav">
          <button 
            onClick={() => handleNavigation('/')} 
            className={`nav-btn ${currentPath === '/' ? 'active' : ''}`}
          >
            Home
          </button>
          <button 
            onClick={() => handleNavigation('/leaderboard')} 
            className={`nav-btn ${currentPath === '/leaderboard' ? 'active' : ''}`}
          >
            Leaderboard
          </button>
          <button 
            onClick={() => handleNavigation('/dex')} 
            className={`nav-btn ${currentPath === '/dex' ? 'active' : ''}`}
          >
            DEX
          </button>
          <button 
            onClick={() => handleNavigation('/activedev')} 
            className={`nav-btn ${currentPath === '/activedev' ? 'active' : ''}`}
          >
            Active Dev
          </button>
          <button 
            onClick={() => handleNavigation('/faq')} 
            className={`nav-btn ${currentPath === '/faq' ? 'active' : ''}`}
          >
            F.A.Q.
          </button>
            <button 
              onClick={() => handleNavigation('/api-docs')} 
              className={`nav-btn ${currentPath === '/api-docs' ? 'active' : ''}`}
            >
              API
            </button>
          <div className="search-container desktop-search">
            <input
              type="text"
              placeholder="Search Dev Wallet..."
              value={searchWallet}
              onChange={(e) => setSearchWallet(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              className="search-input"
            />
            <button onClick={handleSearch} className="search-btn">
              🔍
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <div className="mobile-nav">
          <button 
            onClick={() => handleNavigation('/')} 
            className={`nav-btn ${currentPath === '/' ? 'active' : ''}`}
          >
            Home
          </button>
          <button 
            onClick={() => handleNavigation('/leaderboard')} 
            className={`nav-btn ${currentPath === '/leaderboard' ? 'active' : ''}`}
          >
            Leaderboard
          </button>
          <button 
            onClick={() => handleNavigation('/dex')} 
            className={`nav-btn ${currentPath === '/dex' ? 'active' : ''}`}
          >
            DEX
          </button>
          <button 
            onClick={() => handleNavigation('/activedev')} 
            className={`nav-btn ${currentPath === '/activedev' ? 'active' : ''}`}
          >
            Active Dev
          </button>
          <button 
            onClick={() => handleNavigation('/faq')} 
            className={`nav-btn ${currentPath === '/faq' ? 'active' : ''}`}
          >
            F.A.Q.
          </button>
            <button 
              onClick={() => handleNavigation('/api-docs')} 
              className={`nav-btn ${currentPath === '/api-docs' ? 'active' : ''}`}
            >
              API
            </button>
          <div className="search-container mobile-search">
            <input
              type="text"
              placeholder="Search Dev Wallet..."
              value={searchWallet}
              onChange={(e) => setSearchWallet(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              className="search-input"
            />
            <button onClick={handleSearch} className="search-btn">
              🔍
            </button>
          </div>
        </div>
      </div>

    </header>
  );
}

export default Header;

